import { PapiDeviation } from '@wix/da-papi-types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { removeBackground, upscaleDeviation } from '../../../redux/dreamup/actions';
import { useCallback } from 'react';

/**
 * Which action will be performed once the user has confirmed their choice.
 *
 * The string values in this enum map to translations, so careful changing them.
 */
export enum SpendConfirmationActionType {
  Upscale = 'upscale',
  RemoveBackground = 'remove_background',
}

export function useSpendConfirmationAction(
  actionType: SpendConfirmationActionType,
  deviation: PapiDeviation
) {
  const dispatchUpscaleDeviation = useAction(upscaleDeviation);
  const dispatchRemoveBackground = useAction(removeBackground);

  return useCallback(
    (spendPoints: boolean) => {
      switch (actionType) {
        case SpendConfirmationActionType.RemoveBackground:
          return dispatchRemoveBackground(deviation, spendPoints);
        case SpendConfirmationActionType.Upscale:
        default:
          return dispatchUpscaleDeviation(deviation, spendPoints);
      }
    },
    [actionType, deviation, dispatchUpscaleDeviation, dispatchRemoveBackground]
  );
}
